import React, { useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

const RunningNumbers = ({ className, ...rest }) => {
  const [viewPortEntered, setViewPortEntered] = useState(false);
  return (
  <>
    <div className="container-fluid runningNumbersdiv">
        <div className="row">
            <div className="col-md-3 runningNumberscoldor">
               <center>
                    <div>
                        <CountUp end={10} redraw={true}>
                            {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start} delayedCall>
                                    <h1 className="countfontsize" ref={countUpRef} />
                                </VisibilitySensor>
                            )}
                        </CountUp>
                    </div>
                    <div><h5>Happy Clients</h5></div>
                </center>
            </div>
            <div className="col-md-3 runningNumberscoldor">
               <center>
                    <div>
                        <CountUp end={5} redraw={true}>
                            {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start} delayedCall>
                                    <h1 className="countfontsize" ref={countUpRef} />
                                </VisibilitySensor>
                            )}
                        </CountUp>
                    </div>
                    <div><h5>Project Complete</h5></div>
                </center>
            </div>
            <div className="col-md-3 runningNumberscoldor">
                <center>
                    <div>
                        <CountUp end={7} redraw={true}>
                            {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start} delayedCall>
                                    <h1 className="countfontsize" ref={countUpRef} />
                                </VisibilitySensor>
                            )}
                        </CountUp>
                    </div>
                    <div><h5>Team Members</h5></div>
                </center>
            </div> 
            <div className="col-md-3">
               <center>
                    <div>
                        <CountUp end={1} redraw={true}>
                            {({ countUpRef, start }) => (
                                <VisibilitySensor onChange={start} delayedCall>
                                    <h1 className="countfontsize" ref={countUpRef} />
                                </VisibilitySensor>
                            )}
                        </CountUp>
                    </div>
                    <div><h5>Wining Awards</h5></div>
                </center>
            </div>   
        </div>
    </div>
      
  </>
  );
};

export default RunningNumbers;